import { render, staticRenderFns } from "./CRMTable.vue?vue&type=template&id=02358aaf&scoped=true"
import script from "./CRMTable.vue?vue&type=script&lang=js"
export * from "./CRMTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02358aaf",
  null
  
)

export default component.exports